import React, { useLayoutEffect } from 'react'
import Footer from '../Component/Footer/Footer'
import FooterNav from '../Component/AppComponent/Footer/FooterNav'

const ReturnPolicy = () => {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    return (
        <div>
            <div>
                <div className='Terms-and-conditions-page'>
                    <div className='container'>
                        <div className='Terms-and-conditions-page'>
                            <h2>Return Policy</h2>
                            <p>We are committed to ensuring your satisfaction with every purchase. This return policy outlines the procedures and conditions under which products may be returned, exchanged, or refunded.</p>

                            <h3>Returns (For Orders Within India Only 🇮🇳)</h3>
                            <p>Customers in India may request a return within 7 days of receiving their order. After this period, unfortunately, we will not be able to offer refunds or exchanges.</p>

                            <h3>To be eligible for a return, the product must:</h3>
                            <p>Be unused and in its original condition</p>
                            <p>Have all original tags, barcodes</p>
                            <p>Be returned with clear photographs showing the product neatly folded and all packaging elements visible</p>
                            <p>A restocking fee of ₹1000 will be deducted from the refund amount. Certain items may not be eligible for return based on their nature or condition.</p>

                            <h3>How to Initiate a Return</h3>
                            <p>To begin the return process:</p>
                            <p>Complete the Return Request Form available on our platform.</p>
                            <p>Our support team will review your request.</p>
                            <p>If approved, a return label will be provided.</p>
                            <p>Prepare the product with proper packaging and drop it off at your local courier/post office.</p>
                            <p>All returns should be shipped back to our designated warehouse. The shipping timeline may vary depending on your location. Once the return is received, please allow 3 to 7 working days for inspection and processing. If the return is approved, a confirmation will be sent, and the refund will be processed within 3 to 5 business days to the original payment method.</p>

                            <h3>Exchanges (India Only)</h3>
                            <p>If you would like to exchange an item:</p>
                            <p>Fill out the Exchange Request Form.</p>
                            <p>Once your request is reviewed and approved, detailed instructions will be provided.</p>
                            <p>The exchanged product will typically be delivered within 5 to 7 working days.</p>
                            <p><strong>Please note</strong> : Once an item has been exchanged, it becomes a final sale and cannot be returned.</p>

                            <h3>International Orders</h3>
                            <p><strong>Returns</strong>: We accept returns from international customers. However, shipping costs and any associated fees will be the customer’s responsibility. A return request must be submitted first, and if approved, an unpaid shipping label will be issued.</p>
                            <p><strong>Exchanges</strong>: At this time, international exchanges are not supported.</p>

                            <h3>Refunds</h3>
                            <p>Refunds are credited to the original payment method within 7 to 8 business days after approval. After receiving and inspecting the return, our team will notify you of the outcome. If approved, your refund will be initiated promptly.</p>
                            <p>If you have received a refund confirmation but haven't seen the amount reflect in your account, please wait 2 to 7 working days before reaching out, as bank processing times can vary.</p>

                            <h3>Missing or Incomplete Items</h3>
                            <p>If you suspect that an item is missing from your package:</p>
                            <p>Thoroughly check the packaging and padding.</p>
                            <p>Some items may be shipped separately.</p>
                            <p>If the issue persists, contact us within 7 days of delivery with the following:</p>
                            <p>A photo of the shipping label</p>
                            <p>Image of the box and its contents</p>
                            <p>A brief explanation of the issue</p>
                            <p>Your order number</p>
                            <p>Our team will guide you through the next steps.</p>

                            <h3>Lost Packages</h3>
                            <p>If your tracking information shows the order has been delivered to the correct address, we are not responsible for lost or stolen packages. In such cases, reach out to our support team, and we’ll do our best to assist you.</p>

                            <h3>Order Modifications & Cancellations</h3>
                            <p>Orders are processed promptly, especially those placed on weekdays. Therefore, once an order is confirmed, modifications to the delivery address, delivery method, or payment option may not be possible.</p>
                            <p>For orders placed on weekends or public holidays, you may request cancellation or changes within 24 hours of placing the order by contacting our support team.</p>
                        </div>

                        <Footer />
                        <FooterNav />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReturnPolicy
